// table列数据
export const tableProps = [
  {
    labelName: "所属行政区划",
    prop: "areaFullName",
  },
  {
    labelName: "用户名称",
    prop: "userName",
  },
  {
    labelName: "单位名称",
    prop: "unitName",
  },
  {
    labelName: "真实姓名",
    prop: "realName",
  },
  {
    labelName: "单位状态",
    prop: "unitStatus",
    formatValue: function (row) {
      switch (row["unitStatus"]) {
        case 0:
          return <el-tag type="info">无状态</el-tag>;
        case 1:
          return <el-tag type="info">已提交</el-tag>;
        case 2:
          return <el-tag type="info">受理中</el-tag>;
        case 3:
          return <el-tag type="success">激活</el-tag>;
        case 4:
          return (
            <el-tag type="danger" effect="plain">
              注销
            </el-tag>
          );
        case 5:
          return (
            <el-tag type="danger" effect="plain">
              吊销
            </el-tag>
          );
        case 6:
          return (
            <el-tag type="danger" effect="plain">
              拒绝
            </el-tag>
          );
        default:
          return "-";
      }
    },
  },
  {
    labelName: "角色名称",
    prop: "roleName",
  },
];

export const searchItems = [
  {
    type: "singleSelect",
    name: "用户类型",
    col: 6,
    code: "userType",
    enum: [
      { label: "管理部门", value: 1 },
      { label: "测绘单位", value: 2 },
    ],
    defaultVal: 1,
    clearable: false,
  },
  {
    type: "input",
    name: "关键字",
    col: 6,
    code: "keyWords",
    placeholder: "用户名/真实姓名/单位名称",
  },
  {
    type: "singleSelect",
    name: "所属角色",
    col: 6,
    code: "roleIds",
    multiple: true,
    fcName: "getRoels",
    dicCodeData: [],
  },
  {
    type: "singleSelect",
    name: "资质等级",
    col: 6,
    code: "qualificationGrades",
    multiple: true,
    enum: [
      { label: "无资质", value: 0 },
      { label: "甲级", value: 1 },
      { label: "乙级", value: 2 },
      { label: "甲级导航电子地图", value: 5 },
    ],
  },
  {
    type: "cascader",
    name: "行政区划",
    col: 6,
    code: "areaIds",
    api: "getCityTree",
    leafLength: 2,
    defaultLevVal: 1,
    filterable: true,
    placeholder: "请选择省/市/区",
    props: { checkStrictly: true },
  },
];

// 角色设置 信息修改 密码重置
// table 操作按钮
export const operateButtons = [
  {
    name: "登录",
    icon: "Upload",
    key: "login",
    dynamicDiable: (row) => {
      return (
        [4, 5, 6].includes(row.unitStatus) ||
        row.userName.endsWith("已注销") ||
        row.ifAction == 0
      );
    },
  },
];
